import { useState, useCallback } from 'react';
import { getSingleCourseReport } from '../../service/AdminService/courseService';
import { showErrorMessage } from '../../components/shared/pagination/messages';

export const useSingleCourseReport = () => {
    const [data, setData] = useState({ content: [], totalElements: 0 });

    const fetchSingleCourseReport = useCallback(async (courseId , params = {}) => {
        if (!courseId) return;
        try {
            const response = await getSingleCourseReport(courseId, params);
            setData(response);
            return response;
        } catch (error) {
            showErrorMessage(error.message || "Failed to load course report");
        }
    }, []);

    return { data,fetchSingleCourseReport };
};